// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__PWUMt","LoginBox":"Login_LoginBox__IbKQz"};